export default __webpack_public_path__ + "static/media/streaks 125.ba43f15e.svg";